import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { currentUrl } from "../../url";

export const reviewsApi = createApi({
  reducerPath: "reviewsApi",
  baseQuery: fetchBaseQuery({ 
    baseUrl: currentUrl,
  prepareHeaders: (headers) => {
      // Читаем токен при каждом запросе, чтобы использовать актуальное значение
      const accessToken = localStorage.getItem("accessToken")
      if (accessToken) {
        // Убеждаемся, что токен имеет правильный формат (Bearer префикс)
        const token = accessToken.startsWith("Bearer ") 
          ? accessToken 
          : `Bearer ${accessToken}`
        headers.set("Authorization", token)
        headers.set("Accept", "application/json")
        // headers.set('Content-type', 'x-www-form-urlencoded')
      }
      return headers
    },
  }),
   
  tagTypes: ["Reviews"],
  endpoints: (builder) => ({
   
    getReviews: builder.query({
      query: ({page = 1, perPage = 5, limit}) => `/master/reviews?page=${page}&perPage=${perPage}&limit=${limit}`,
      
      providesTags: ["Reviews"],
    }),
    
    updateReviews: builder.mutation({
      query: ({ id, body }) => ({
        url: `/master/reviews/${id}`,
        method: "PATCH", 
        body: body,
      }),
      invalidatesTags: ["Reviews"], 
    }),
  }),
});

export const { useGetReviewsQuery, useUpdateReviewsMutation } = reviewsApi;
